var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import AddIcon from '@assets/svg/addIcon.svg';
import SuccessIcon from '@assets/svg/SuccessIcon.svg';
import './TabletsControlPage.scss';
import { useAppSelector, useDebounce } from '@/hooks/redux';
import InputSearch from '@/components/InputSearch/InputSearch';
import Modal from './Modals/addTabletModal';
import Input from '@/components/Input/Input';
import { useForm } from 'react-hook-form';
import TabletItem from './TabletItem/tabletItem';
import { useCreateTabletsMutation, useDeleteTabletMutation, useEditTabletsMutation, useGetTabletsWithSearchQuery, } from '@/services/tabletsApi';
import SelectRestaurant from '../../../components/SelectRestaurant/SelectRestaurant';
import { useGetRestaurantsQuery } from '@/services/restaurantsApi';
import Loader from '@/components/Loader/Loader';
import CenterModal from '@/components/CenterModal/CenterModal';
import { useGetUserByIdQuery } from '@/services/usersApi';
var TabletsControlPage = function () {
    var _a, _b;
    var _c = useState(''), search = _c[0], setSearch = _c[1];
    var _d = useState(0), show = _d[0], setShow = _d[1];
    var _e = useState(null), restaurant = _e[0], setRestaurant = _e[1];
    var _f = useState(false), showSuccessModal = _f[0], setShowSuccessModal = _f[1];
    var _g = useForm({ defaultValues: { deviceId: '', tableNumber: '' } }), register = _g.register, handleSubmit = _g.handleSubmit, errors = _g.formState.errors, reset = _g.reset;
    var _h = useState(1), page = _h[0], setPage = _h[1];
    var limit = 10;
    var user = useAppSelector(function (state) { return state.authStich.currentUser; });
    var currentUserRole = (_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.role;
    var isClient = currentUserRole === 'сотрудник';
    var _j = useGetUserByIdQuery({ id: user === null || user === void 0 ? void 0 : user.id }), userData = _j.data, isUserDataSuccess = _j.isSuccess;
    var restId = (_b = userData === null || userData === void 0 ? void 0 : userData.restaurant) === null || _b === void 0 ? void 0 : _b.id;
    // API hooks
    var _k = useGetTabletsWithSearchQuery({
        page: page,
        limit: limit,
        search: search,
        restId: isClient ? restId : restaurant === null || restaurant === void 0 ? void 0 : restaurant.id,
    }, { skip: !restaurant }), data = _k.data, isLoading = _k.isLoading, error = _k.error, refetchTablets = _k.refetch;
    var _l = useCreateTabletsMutation(), createTablet = _l[0], _m = _l[1], createError = _m.error, isLoadingCreateTablet = _m.isLoading, isCreateSuccess = _m.isSuccess;
    var _o = useEditTabletsMutation(), editTablet = _o[0], _p = _o[1], editError = _p.error, isLoadingEditTablet = _p.isLoading, isEditSuccess = _p.isSuccess;
    var _q = useDeleteTabletMutation(), deleteTablet = _q[0], _r = _q[1], deleteError = _r.error, isLoadingDeleteTablet = _r.isLoading, isDeleteSuccess = _r.isSuccess;
    var _s = useGetRestaurantsQuery({}), restaurantsData = _s.data, isRestaurantsLoading = _s.isLoading;
    // Fetch initial data
    useEffect(function () {
        if (restaurantsData && restaurantsData.length > 0) {
            setRestaurant(restaurantsData[0]);
        }
    }, [restaurantsData]);
    useEffect(function () {
        if (isCreateSuccess || isDeleteSuccess || isEditSuccess) {
            console.log('SuCCess');
            setShowSuccessModal(true);
            var timer_1 = setTimeout(function () {
                setShowSuccessModal(false);
            }, 3000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [isCreateSuccess, isDeleteSuccess, isEditSuccess]);
    useEffect(function () {
        if (restaurant) {
            refetchTablets();
        }
    }, [restaurant]);
    console.log('ERROR', error);
    // Handle errors
    useEffect(function () {
        if (error || editError || createError || deleteError) {
            console.log(error, 'errorerrorerror');
        }
    }, [error, editError, createError, deleteError]);
    // Debounce search
    var debouncedSetSearchText = useDebounce(function (text) {
        setSearch(text);
        setPage(1);
    }, 300);
    // Hide modal
    var hideModal = useCallback(function () {
        setShow(0);
        reset();
    }, [reset]);
    // Submit form
    var onSubmit = function (dataForm) {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!dataForm.tableNumber || Number(dataForm.tableNumber) <= 0) {
                            alert('Номер стола должен быть больше 0');
                            return [2 /*return*/];
                        }
                        if (!(show === 1))
                            return [3 /*break*/, 2];
                        console.log(dataForm);
                        // wait for naming 
                        return [4 /*yield*/, createTablet(__assign(__assign({}, dataForm), { tableNummber: dataForm.tableNumber, restaurantId: isClient ? restId : restaurant === null || restaurant === void 0 ? void 0 : restaurant.id }))];
                    case 1:
                        // wait for naming 
                        _a.sent();
                        hideModal();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(show === 2))
                            return [3 /*break*/, 4];
                        return [4 /*yield*/, editTablet({ body: { tableNumber: dataForm.tableNumber }, id: dataForm.id })];
                    case 3:
                        _a.sent();
                        hideModal();
                        _a.label = 4;
                    case 4:
                        // refetchTablets();
                        reset();
                        hideModal();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Handle delete
    var handleDelete = function (id) {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, deleteTablet({ tabletId: id })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    var handletableNumberChange = function (e) {
        var value = e.target.value;
        if (value === '' || /^[1-9]\d*$/.test(value)) {
            e.target.value = value;
        }
        else {
            e.target.value = value.replace(/\D/g, '');
        }
    };
    var handlePreviousPage = function () {
        if (page > 1) {
            setPage(function (prevPage) { return prevPage - 1; });
        }
    };
    var handleNextPage = function () {
        if (page * limit < ((data === null || data === void 0 ? void 0 : data.total) || 0)) {
            setPage(function (prevPage) { return prevPage + 1; });
        }
    };
    return (_jsxs("div", __assign({ className: 'TabletsControlPage' }, { children: [_jsx(CenterModal, __assign({ show: showSuccessModal, handleClose: function () { setShowSuccessModal(false); } }, { children: _jsxs(ModalSuccessContent, { children: [_jsx(SuccessIcon, {}), "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E"] }) })), _jsx(PageHeader, { children: _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 500, fontSize: '24px' } }, { children: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u043B\u0430\u043D\u0448\u0435\u0442\u0430\u043C\u0438" })) }), _jsxs("div", __assign({ style: { padding: '40px' } }, { children: [!isClient &&
                        _jsx(SelectRestaurant, { isLoading: isRestaurantsLoading, restaurant: restaurantsData || [], setRestaurant: function (item) { return setRestaurant(item); } }), _jsx(InputSearch, { setSearch: debouncedSetSearchText }), _jsx(AddIcon, { onClick: function () {
                            if (restaurantsData && restaurantsData.length) {
                                reset({ deviceId: '', tableNumber: '' });
                                setShow(1);
                            }
                            else {
                                alert('Сперва создайте ресторан!');
                            }
                        }, style: { marginTop: '32px', marginBottom: '24px', cursor: 'pointer' } }), (isLoading) ? (_jsx(LoaderContainer, { children: _jsx(Loader, { width: '50px', height: '50px' }) })) : (_jsx(_Fragment, { children: data && data.data && data.data.length ? (data.data.map(function (item, index) {
                            return _jsx(TabletItem, { onClick: function () {
                                    setShow(2);
                                    reset({ deviceId: item.deviceId, tableNumber: item.tableNumber, id: item.id });
                                }, id: item.deviceId, table: item.tableNumber, onDelete: function () { return handleDelete(item.id); }, isLast: index === 0, isFirst: index === data.data.length - 1, isLoading: isLoadingDeleteTablet }, item.id);
                        }).reverse()) : (_jsxs(TabletsList, { children: [_jsx(EmptyList, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442" }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 400, fontSize: '16px' } }, { children: "\u0417\u0434\u0435\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0441\u044F \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u043B\u0430\u043D\u0448\u0435\u0442\u043E\u0432" }))] })) })), _jsxs(PaginationContainer, { children: [_jsx(ChangePageButton, __assign({ onClick: handlePreviousPage, disabled: page === 1 }, { children: _jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M15 18L9 12L15 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })) })), _jsxs("span", { children: ["\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ", page] }), _jsx(ChangePageButton, __assign({ onClick: handleNextPage, disabled: page * limit >= ((data === null || data === void 0 ? void 0 : data.total) || 0) }, { children: _jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M9 6L15 12L9 18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })) }))] })] })), _jsx(Modal, __assign({ show: show, handleClose: hideModal, modalClassName: 'tablel-modal-class' }, { children: _jsx(ModalContent, { children: _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit), style: {
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                        } }, { children: [_jsx("div", __assign({ style: {
                                    background: '#FFFFFF',
                                    padding: '24px',
                                    borderTopLeftRadius: '8px',
                                    borderTopRightRadius: '8px',
                                    borderTop: '1px solid #E3E3E3',
                                    borderLeft: '1px solid #E3E3E3',
                                    borderRight: '1px solid #E3E3E3'
                                } }, { children: _jsx("span", __assign({ style: {
                                        fontFamily: 'Montserrat Regular',
                                        fontWeight: 600,
                                        fontSize: '16px',
                                        textAlign: 'left',
                                        display: 'block'
                                    } }, { children: "\u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F" })) })), _jsxs("div", __assign({ style: {
                                    background: '#FFFFFF',
                                    padding: '24px',
                                    borderBottomRightRadius: '8px',
                                    borderBottomLeftRadius: '8px',
                                    border: '1px solid #E3E3E3',
                                } }, { children: [_jsx(HeaderText, { children: "ID \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430" }), _jsx(Input, { error: !!errors.deviceId, register: __assign({}, register('deviceId', { required: true })), disabled: show === 2, placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 ID' }), _jsx("div", { style: { height: '24px' } }), _jsx(HeaderText, { children: "\u041D\u043E\u043C\u0435\u0440 \u0441\u0442\u043E\u043B\u0430" }), _jsx(Input, { inputType: 'number', placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440', onChange: handletableNumberChange, error: !!errors.tableNumber, register: __assign({}, register('tableNumber', { required: true })) })] })), _jsxs(ButtonContainer, { children: [!(isLoadingCreateTablet || isLoadingEditTablet) ? (_jsx(Button, __assign({ type: 'submit' }, { children: _jsx("span", __assign({ style: {
                                                fontFamily: 'Montserrat Regular',
                                                fontWeight: 500,
                                                fontSize: '16px',
                                                color: 'white',
                                            } }, { children: show === 1 ? 'Создать' : "Сохранить изменения" })) }))) : (_jsx(Button, { children: _jsx(Loader, { width: '20px', height: '20px' }) })), _jsx(Button, __assign({ type: 'button', style: { background: 'none' }, onClick: hideModal }, { children: _jsx("span", __assign({ style: {
                                                cursor: 'pointer',
                                                fontFamily: 'Montserrat Regular',
                                                fontWeight: 600,
                                                fontSize: '16px',
                                                color: '#000000',
                                                marginLeft: '2vw',
                                            } }, { children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })) }))] })] })) }) }))] })));
};
var PaginationContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin-top: 20px;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  margin-top: 20px;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  justify-content: center;\n  align-items: center;\n"])));
var ChangePageButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #E621D3;\n  color: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 10px;\n  transition: background-color 0.3s;\n\n  &:disabled {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #d11bbf;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"], ["\n  background-color: #E621D3;\n  color: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 10px;\n  transition: background-color 0.3s;\n\n  &:disabled {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #d11bbf;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"])));
var PageHeader = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: #fff;\n    width: 100%;\n    padding-top: 43px;\n    padding-left: 40px;\n    padding-bottom: 27px;\n\n    @media (max-width: 800px) {\n        height: 150px;\n        padding-top: 90px;\n    }\n"], ["\n    background: #fff;\n    width: 100%;\n    padding-top: 43px;\n    padding-left: 40px;\n    padding-bottom: 27px;\n\n    @media (max-width: 800px) {\n        height: 150px;\n        padding-top: 90px;\n    }\n"])));
var TabletsList = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"])));
var ModalContent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    word-wrap: break-word;\n    word-break: break-word;\n    overflow-wrap: break-word;\n\n    @media (max-height: 900px) {\n        height: 600px;\n    }\n\n    @media (max-height: 800px) {\n        height: 500px;\n    }\n\n    @media (max-height: 700px) {\n        height: 400px;\n    }\n\n    @media (max-height: 600px) {\n        height: 340px;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    word-wrap: break-word;\n    word-break: break-word;\n    overflow-wrap: break-word;\n\n    @media (max-height: 900px) {\n        height: 600px;\n    }\n\n    @media (max-height: 800px) {\n        height: 500px;\n    }\n\n    @media (max-height: 700px) {\n        height: 400px;\n    }\n\n    @media (max-height: 600px) {\n        height: 340px;\n    }\n"])));
var ButtonContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: auto;\n    display: flex;\n    flex-direction: row;\n"], ["\n    margin-top: auto;\n    display: flex;\n    flex-direction: row;\n"])));
var Button = styled.button(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: 15px;\n    width: fit-content;\n    border-radius: 30px;\n    background: #E621D3;\n    border: none;\n    cursor: pointer;\n    white-space: nowrap;\n\n    @media (max-width: 768px) {\n        width: 100%;\n        white-space: normal;\n    }\n"], ["\n    padding: 15px;\n    width: fit-content;\n    border-radius: 30px;\n    background: #E621D3;\n    border: none;\n    cursor: pointer;\n    white-space: nowrap;\n\n    @media (max-width: 768px) {\n        width: 100%;\n        white-space: normal;\n    }\n"])));
var HeaderText = styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-family: 'Montserrat Regular';\n    font-weight: 400;\n    font-size: 14px;\n    text-align: left;\n    color: #898989;\n    display: block;\n    margin-bottom: 8px;\n"], ["\n    font-family: 'Montserrat Regular';\n    font-weight: 400;\n    font-size: 14px;\n    text-align: left;\n    color: #898989;\n    display: block;\n    margin-bottom: 8px;\n"])));
var EmptyList = styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-family: 'Montserrat Regular';\n    font-weight: 500;\n    font-size: 24px;\n    text-align: center;\n    margin: 20px 0;\n"], ["\n    font-family: 'Montserrat Regular';\n    font-weight: 500;\n    font-size: 24px;\n    text-align: center;\n    margin: 20px 0;\n"])));
var LoaderContainer = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n"])));
var ModalSuccessContent = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-top: 40px;\n    width: 28vw;\n    display: flex;\n    font-family: 'Montserrat Regular';\n    font-weight: 500;\n    font-size: 20px;\n    gap: 20px;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    @media (max-width: 768px) {\n        width: 80vw;\n        padding: 16px;\n    }\n"], ["\n    margin-top: 40px;\n    width: 28vw;\n    display: flex;\n    font-family: 'Montserrat Regular';\n    font-weight: 500;\n    font-size: 20px;\n    gap: 20px;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    @media (max-width: 768px) {\n        width: 80vw;\n        padding: 16px;\n    }\n"])));
export default TabletsControlPage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
